import { useEffect, useState } from 'react';
import { useParams } from 'react-router-dom';
import { useTenant } from '@/contexts/TenantContext';
import { supabase } from '@/integrations/supabase/client';

/**
 * Resolves the current tenant username (from subdomain/custom domain or URL param)
 * into a user_id. Used by all public-facing pages/hooks to scope queries.
 */
export function useResolveUserId() {
  const { username: tenantUsername } = useTenant();
  const { username: paramUsername } = useParams<{ username: string }>();
  const username = tenantUsername || paramUsername;

  const [userId, setUserId] = useState<string | null>(null);
  const [loading, setLoading] = useState(true);
  const [notFound, setNotFound] = useState(false);

  useEffect(() => {
    if (!username) {
      setLoading(false);
      setNotFound(true);
      return;
    }

    let cancelled = false;
    (async () => {
      const { data } = await supabase.rpc('resolve_username', { p_username: username });
      if (cancelled) return;
      const resolved = (data as any)?.[0]?.user_id ?? null;
      if (resolved) {
        setUserId(resolved);
      } else {
        setNotFound(true);
      }
      setLoading(false);
    })();

    return () => { cancelled = true; };
  }, [username]);

  return { userId, username, loading, notFound };
}
